
// This file is deprecated. Import toast directly from @/hooks/use-toast
import { toast, useToast } from "@/hooks/use-toast";

// Re-export for backward compatibility
export { toast, useToast };

// Add console warning to help identify places still using this import
console.warn("Deprecated import path: use @/hooks/use-toast instead of @/components/ui/use-toast");
